module.exports = __webpack_public_path__ + "static/assembly2-1-4ce1825b8207ce2fd10efbc682192d5f.png";